module.exports = __webpack_public_path__ + "static/media/ic_show_similar.8dab9854.svg";